import { prefixIdName } from './helpers.js';
export const symbolWrapper = ({ id, childPaths, viewBox = '0 0 24 24' }) => `<symbol ${id ? `id="${prefixIdName(id)}"` : ''} viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg">
  ${childPaths}
</symbol>`;
export const spritemapSvgWrapper = (symbols) => `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  ${symbols.join('')}
</svg>`;
